import { useMemo } from 'react';
import { hasSold, SmartSendFilter, SmartSendSummary, SortField } from '../../../lib/helpers/SmartSendFilterApplier';
import { EditType } from '../item/EditType';
import { SmartSendFilterBarDesktop } from './SmartSendFilterBarDesktop';
import { SmartSendFilterBarMobile } from './SmartSendFilterBarMobile';

interface props {
  filter: SmartSendFilter;
  filterKey: string;
  summary: SmartSendSummary;
  actions: SortField[];
  setAction: (actions: EditType) => void;
  marketplaceStates: string[];
  update: (filter: SmartSendFilter) => void;
  openFilter: () => void;
  openSortBy: () => void;
  selectAll: () => void;
  isXs: boolean;
}

export interface iProps extends props {
  sold: boolean;
  activeFilters: number;
}

export default function SmartSendFilterBar(props: props) {
  const sold = useMemo(() => hasSold(props.filter), [props.filter]);
  const activeFilters = useMemo(
    () =>
      props.filter.FilterSelections.filter(
        (x) => !['Status', 'Error'].includes(x.Name) && (x.Include.length > 0 || x.Exclude.length > 0)
      ).length,
    [props.filter]
  );

  return props.isXs ? (
    <SmartSendFilterBarMobile {...props} sold={sold} activeFilters={activeFilters} />
  ) : (
    <SmartSendFilterBarDesktop {...props} sold={sold} activeFilters={activeFilters} />
  );
}
